/* eslint-disable max-len */
/**
 * Awvent - Awvent Contacts API
 * Awvent User Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
        HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../../../../encoder';

import { Observable }                                        from 'rxjs';
import { environment }                                        from '../../../../../environments/environment';

import { BooleanWebApiResponse } from '../../../../shared/common/models/booleanWebApiResponse';
import { ContactCreateCommand } from '../model/contactCreateCommand';
import { ContactDtoIListWebApiPagedResponse } from '../model/contactDtoIListWebApiPagedResponse';
import { ContactDtoWebApiResponse } from '../model/contactDtoWebApiResponse';
import { ContactUpdateCommand } from '../model/contactUpdateCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../../../../variables';
import { Configuration }                                     from '../../../../configuration';


 @Injectable()
 export class ContactService {

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

     protected basePath = environment.api.contacts;

     constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
         if (basePath) {
             this.basePath = basePath;
         }
         if (configuration) {
             this.configuration = configuration;
             this.basePath = basePath || configuration.basePath || this.basePath;
         }
     }

     /**
      *
      *
      * @param xTenantId
      * @param orderBy
      * @param isOrderByDescending
      * @param searchText
      * @param pageNumber
      * @param pageSize
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public contactGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<ContactDtoIListWebApiPagedResponse>;
     public contactGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDtoIListWebApiPagedResponse>>;
     public contactGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDtoIListWebApiPagedResponse>>;
     public contactGet(xTenantId: string, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling contactGet.');
         }

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (orderBy) {
             orderBy.forEach((element) => {
                 queryParameters = queryParameters.append('OrderBy', element as any);
             });
         }
         if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
             queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending as any);
         }
         if (searchText !== undefined && searchText !== null) {
             queryParameters = queryParameters.set('SearchText', searchText as any);
         }
         if (pageNumber !== undefined && pageNumber !== null) {
             queryParameters = queryParameters.set('PageNumber', pageNumber as any);
         }
         if (pageSize !== undefined && pageSize !== null) {
             queryParameters = queryParameters.set('PageSize', pageSize as any);
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<ContactDtoIListWebApiPagedResponse>('get',`${this.basePath}/Contact`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contactIdDelete(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public contactIdDelete(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public contactIdDelete(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public contactIdDelete(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling contactIdDelete.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling contactIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/Contact/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public contactIdGet(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<ContactDtoWebApiResponse>;
     public contactIdGet(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDtoWebApiResponse>>;
     public contactIdGet(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDtoWebApiResponse>>;
     public contactIdGet(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (id === null || id === undefined) {
             throw new Error('Required parameter id was null or undefined when calling contactIdGet.');
         }

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling contactIdGet.');
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<ContactDtoWebApiResponse>('get',`${this.basePath}/Contact/${encodeURIComponent(String(id))}`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param body
      * @param xRequestId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public contactPost(xTenantId: string, body?: ContactCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<ContactDtoWebApiResponse>;
     public contactPost(xTenantId: string, body?: ContactCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDtoWebApiResponse>>;
     public contactPost(xTenantId: string, body?: ContactCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDtoWebApiResponse>>;
     public contactPost(xTenantId: string, body?: ContactCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling contactPost.');
         }

         let headers = this.defaultHeaders;
         if (xRequestId !== undefined && xRequestId !== null) {
             headers = headers.set('x-request-id', String(xRequestId));
         }
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<ContactDtoWebApiResponse>('post',`${this.basePath}/Contact`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public contactPut(xTenantId: string, body?: ContactUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<ContactDtoWebApiResponse>;
     public contactPut(xTenantId: string, body?: ContactUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDtoWebApiResponse>>;
     public contactPut(xTenantId: string, body?: ContactUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDtoWebApiResponse>>;
     public contactPut(xTenantId: string, body?: ContactUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling contactPut.');
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<ContactDtoWebApiResponse>('put',`${this.basePath}/Contact`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      * @param consumes string[] mime-types
      * @return true: consumes contains 'multipart/form-data', false: otherwise
      */
      private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

 }
